import Index from "./Index.vue";
import SerialStart from "./SerialStart.vue";
import SerialConfirm from "./SerialConfirm.vue";
import SerialEnd from "./SerialEnd.vue";
import RegistrationStart from "./RegistrationStart.vue";
import RegistrationConfirm from "./RegistrationConfirm.vue";
import Order from "./Order.vue";
import OrderConfirm from "./OrderConfirm.vue";
import Delivery from "./Delivery.vue";
import DeliveryConfirm from "./DeliveryConfirm.vue";
import DeliveryEnd from "./DeliveryEnd.vue";
import ProductDetail from "./ProductDetail.vue";
import QA from "./QA.vue";

export default {
  routes: [
    {
      path: "/shopping-in0001",
      component: Index,
    },
    {
      path: "/shopping-in0001/serial",
      component: SerialStart,
    },
    {
      path: "/shopping-in0001/serial/confirm",
      component: SerialConfirm,
    },
    {
      path: "/shopping-in0001/serial/end",
      component: SerialEnd,
    },
    {
      path: "/shopping-in0001/registration/:uux",
      component: RegistrationStart,
    },
    {
      path: "/shopping-in0001/registration",
      component: RegistrationStart,
    },
    {
      path: "/shopping-in0001/registration/confirm",
      component: RegistrationConfirm,
    },
    {
      path: "/shopping-in0001/order",
      component: Order,
    },
    {
      path: "/shopping-in0001/order/confirm",
      component: OrderConfirm,
    },
    {
      path: "/shopping-in0001/delivery",
      component: Delivery,
    },
    {
      path: "/shopping-in0001/delivery/confirm",
      component: DeliveryConfirm,
    },
    {
      path: "/shopping-in0001/delivery/end",
      component: DeliveryEnd,
    },
    {
      path: "/shopping-in0001/products/:productNo",
      component: ProductDetail,
    },
    {
      path: "/shopping-in0001/qa",
      component: QA,
    },
  ],
};
